import React from 'react';
import PropTypes from 'prop-types';

import {cn} from 'spa/css';

const Divider = ({children, className, ...rest}) => (
  <div {...rest} className={cn('form-divider', className)}>
    <span className="form-divider-text">{children}</span>
  </div>
);
Divider.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Divider;



// WEBPACK FOOTER //
// ./spa/Components/Form/Divider.jsx